export default __webpack_public_path__ + "static/media/texture.587bb17b.svg";